import { render } from "./UpItem.vue?vue&type=template&id=0f3a2470&scoped=true"
import script from "./UpItem.vue?vue&type=script&lang=js"
export * from "./UpItem.vue?vue&type=script&lang=js"

import "./UpItem.vue?vue&type=style&index=0&id=0f3a2470&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao_up_up_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3a2470"]])

export default __exports__